import "../../dashboard/DashboardLayout.css";
import { Autocomplete, Box, LoadingOverlay, Table } from "@mantine/core";
import { useCallback, useEffect, useState } from "react";
import "../retailerAccess/retailerPayment.css";
import {
  getPaymentManagementOutlets,
  updatePaymentBlockStatus,
  getOutletsWithPaymentBlocked
} from "../../../services/bankingService";
import { useAuth } from "../../../providers/AuthProvider";
import {
  outletListAPiResponsePaymentBlock,
  outletListPaymentBlock,
  paymentBlockType,
  popupType,
} from "../../../types/types";
import { GenericPopUp } from "../../popup/genericPopUp";
import { Heading } from "../heading/heading";
import { CircleX } from "tabler-icons-react";
import { TableDataPaymentBlock } from "./tableDataPaymentBlock";

export function PaymentManagement() {
  const [data, setData] = useState<outletListAPiResponsePaymentBlock>({ features: [] });
  const [outletsWithPaymentEnabledState, setOutletsWithPaymentEnabledState] =
    useState<paymentBlockType[]>([]);
  const [loaderShowOnCreateAccount, setLoaderShowOnCreateAccount] =
    useState<boolean>(false);
  const [openGenericModal, setOpenGenericModal] = useState(false);
  const [popupType, setPopupType] = useState<popupType>("Alert");
  const [genericMessage, setGenericMessage] = useState("");
  const [searched, setSearched] = useState("");
  const [rows, setRows] = useState<outletListPaymentBlock[]>(data.features);
 

  const authContext = useAuth();


  const getOutletList = useCallback(async () => {
    const outlets = await getPaymentManagementOutlets();
    setData(outlets)
    return outlets;
  }, [authContext]);


  const odPaymentProvider = useCallback(async () => {
    const allStatusList = await getOutletsWithPaymentBlocked();
    setOutletsWithPaymentEnabledState(allStatusList.features);
  },[getOutletsWithPaymentBlocked]);

  useEffect(() => {
    const method = async () => {
      setLoaderShowOnCreateAccount(true);
      const resp = await getOutletList();
      setRows(resp?.features);
      odPaymentProvider();
      setLoaderShowOnCreateAccount(false);
    };
    method();
  }, [getOutletList, odPaymentProvider]);

  const openPopup = (message: string, type: popupType) => {
    setPopupType(type);
    setGenericMessage(message);
    setOpenGenericModal(true);
  };

  const searchList = [
    {
      id: 'login_id',
      title: 'Outlet ID'
    },
    {
      id: 'outlet_name',
      title: 'Outlet Name'
    },
  ]

  const requestSearch = (searchedVal: any, category: any) => {

    const filteredRows = data.features.filter((row) => {
      return row[category as keyof outletListPaymentBlock].toLowerCase().indexOf(searchedVal.toLowerCase()) > -1;
    });
    setRows(filteredRows);
  };

  const cancelSearch = () => {
    setSearched("");
    setRows(data.features);
  };

  const submitForm = async (paymentStatus: any, login_id: string, type: string) => {
    setLoaderShowOnCreateAccount(true);
      const emptyArray: { loginId: string; type: any; active: string; }[] = [];
      const paymentSubscriptionRequestBody = {
        loginId: "",
        type: "",
        active: ""
      };
        let obj = JSON.parse(JSON.stringify(paymentSubscriptionRequestBody));
        obj.loginId = login_id;
        obj.type = type;
        obj.active = paymentStatus.paymentBlock === true ? "inactive" : "active";
        emptyArray.push(obj);
      try{
       const submit = await updatePaymentBlockStatus(emptyArray);
       setLoaderShowOnCreateAccount(false);
       openPopup(submit[0].status, "Success");
        odPaymentProvider();
      }catch(e:any){
        setLoaderShowOnCreateAccount(false);
        openPopup(e.response.data.message, "Error");
      }
  };

  const searchData =
    searched.trim().length > 0 
      ? searchList.map((provider) => ({...provider, value: `${searched} in ${provider.title}`}))
      : [];

  return (
    <div className="app-container">
      {loaderShowOnCreateAccount && (
        <LoadingOverlay
          visible={loaderShowOnCreateAccount}
          style={{ position: "fixed" }}
        />
      )}

      <GenericPopUp
        message={genericMessage}
        type={popupType}
        openGenericModal={openGenericModal}
        setOpenGenericModal={setOpenGenericModal}
      />

<Autocomplete className="searchbar"
        value={searched}
        onChange={(value) => {
          if (value === "") setRows(data.features);
          setSearched(value)
        }}
        placeholder="Start typing to see options"
        data={searchData}
        onItemSubmit={(item) => {
          requestSearch(searched, item.id);
          setSearched(searched);
        }}
        rightSection={<CircleX size={20}
        strokeWidth={1}
        color={'grey'}
        onClick= {() => cancelSearch()}/>}
    />

      <Box className="mainBox">
        <Box className="headingAndTilesContainer">
          <Heading mainHeading="Retailer Payment Control" subHeading="Please select a payment method to disable payment"/>
          <Box>
            <Table
              className="paymentTable"
              verticalSpacing="xs"
              fontSize="xs"
              horizontalSpacing={1}
              highlightOnHover
            >
              <thead>
                <tr>
                  <th>Outlet ID</th>
                  <th>Outlet Name</th>
                  <th style={{textAlign: "center"}}>Payment block</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {rows?.map((dat: outletListPaymentBlock) => (
                  <TableDataPaymentBlock
                    dat={dat}
                    submitForm={submitForm}
                    paymentBlocked = {outletsWithPaymentEnabledState?.filter((obj) => (obj.login_id === dat.login_id))}
                  />
                ))}
              </tbody>
            </Table>
          </Box>
        </Box>
      </Box>
      
    </div>
  );
}
